"use client";

import { memo } from "react";
import { Box } from "@chakra-ui/react";
import PrivateNavbar from "../navigation/PrivateNavbar";

function PrivateShellViewport({ children }: { children: React.ReactNode }) {
  return (
    <Box display="flex" minH="100vh">
      <Box
        flex="1"
        display="flex"
        flexDirection="column"
      >
        <PrivateNavbar />
        <Box flex="1" overflow="auto">
          {children}
        </Box>
      </Box>
    </Box>
  );
}

export default memo(PrivateShellViewport);
